import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["title", "file", "submitButton"];

  connect() {
    this.refresh();
  }

  refresh() {
    if (!this.hasSubmitButtonTarget) return;
    const hasTitle = this.hasTitleTarget && this.titleTarget.value.trim().length > 0;
    const hasFile = this.hasFileTarget && this.fileTarget.files.length > 0;
    this.submitButtonTarget.disabled = !hasTitle && !hasFile;
  }
}
